import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';

import { BRN_RELATED_DOCUMENT_TYPES } from '../../constants/DocumentChecklistItemConstants';
import { IListingOffer, IListingOfferBasic, IRequestStatusMap } from '../../declarations';

export const listingOffer = (state): IListingOffer | undefined => {
  const immutableListingOffer = state.getIn(['resaleClosingDashboard', 'listingOffer']);
  return isEmpty(immutableListingOffer) ? undefined : immutableListingOffer.toJS();
};

export const listingOfferError = state =>
  state.getIn(['resaleClosingDashboard', 'listingOfferError']);
export const listingOfferIsLoading = state =>
  state.getIn(['resaleClosingDashboard', 'listingOfferIsLoading']);

export const claimListingOfferByTokenRequestStatus = state =>
  state.getIn(['resaleClosingDashboard', 'claimListingOfferByTokenRequestStatus']).toJS();

export const listingOffers = (state): IListingOfferBasic[] | undefined => {
  const immutableListingOffers = state.getIn(['resaleClosingDashboard', 'listingOffers']);
  return isEmpty(immutableListingOffers) ? undefined : immutableListingOffers.toJS();
};

export const listingOffersError = state =>
  state.getIn(['resaleClosingDashboard', 'listingOffersError']);
export const listingOffersIsLoading = state =>
  state.getIn(['resaleClosingDashboard', 'listingOffersIsLoading']);

export const generateSellerResponseRequestStatus = state =>
  state.getIn(['resaleClosingDashboard', 'generateSellerResponseRequestStatus']).toJS();

export const uploadChecklistDocumentRequests = (state): IRequestStatusMap =>
  state.getIn(['resaleClosingDashboard', 'uploadChecklistDocumentRequests']).toJS();

export const removeChecklistDocumentRequests = (state): IRequestStatusMap =>
  state.getIn(['resaleClosingDashboard', 'removeChecklistDocumentRequests']).toJS();

export const documentChecklistItems = state => {
  const documentChecklistItems = state.getIn([
    'resaleClosingDashboard',
    'listingOffer',
    'document_checklist',
    'document_checklist_items',
  ]);
  return isEmpty(documentChecklistItems) ? [] : documentChecklistItems.toJS();
};

export const getContractDocumentChecklistItems = () =>
  createSelector(documentChecklistItems, items => {
    return items.filter(item => !BRN_RELATED_DOCUMENT_TYPES.has(item.document_type));
  });

export const getBrnDocumentChecklistItems = () =>
  createSelector(documentChecklistItems, items => {
    return items.filter(item => BRN_RELATED_DOCUMENT_TYPES.has(item.document_type));
  });

export const additionalDocumentTypes = state => {
  const additionalDocumentTypes = state.getIn([
    'resaleClosingDashboard',
    'listingOffer',
    'unsolicited_buyer_submittable_document_types',
  ]);
  return isEmpty(additionalDocumentTypes) ? [] : additionalDocumentTypes.toJS();
};

export const getContractAdditionalDocumentTypes = () =>
  createSelector(additionalDocumentTypes, documentTypes => {
    return documentTypes.filter(documentType => !BRN_RELATED_DOCUMENT_TYPES.has(documentType));
  });

export const getBrnAdditionalDocumentTypes = () =>
  createSelector(additionalDocumentTypes, documentTypes => {
    return documentTypes.filter(documentType => BRN_RELATED_DOCUMENT_TYPES.has(documentType));
  });
